import React from "react";
import PropTypes from "prop-types";
import {
  imagePrefix,
  urlPrefix,
} from "../../../utils/helperServices";
import {  useRouter } from "../../atoms/DependencyHelper";
import UpgradeComponent from "../upgradeModal/UpgradeModal";
import * as Analytics from "../../../services/analyticsUtag";

const SyncError = ({ navigate, handleCancel }) => {
  const sendAnalitycsLink = (additionalInfo) => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_event",
        "page_name",
        "page_channel",
        "page_master_tab",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      link_type: "o",
      ...additionalInfo,
    });
  };

  const router = useRouter();

  return (
    <UpgradeComponent
      showModal={true}
      toggleModal={handleCancel}
      displayData={{
        iconUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
        title: "Oops!",
        analyticTitle: "Login DID Sync Failure",
        description: "We are experiencing some technical difficulties right now.<br /><br />Please try again later.",
        primaryButtonText: "Call me back",
        onClickHandlerPrimary: () => {
          sendAnalitycsLink({
            link_name: `checkout: did sync failure: call me back`,
            link_type: "o",
          });
          router.push(
            `${urlPrefix}/forms/ecommerce`
          );
        },
      }}
    />
  );
};

SyncError.propTypes = {
  navigate: PropTypes.func,
  handleCancel: PropTypes.func
};

export default SyncError;
